<a
  #activeLink="routerLinkActive"
  [routerLink]="item().disabled ? null : item().routerLink"
  [queryParams]="item().disabled ? null : item().queryParams"
  routerLinkActive="bg-standard-hover-main"
  [routerLinkActiveOptions]="{
    paths: 'subset',
    queryParams: 'exact',
    matrixParams: 'ignored',
    fragment: 'ignored',
  }"
  ariaCurrentWhenActive="page"
  [attr.aria-disabled]="item().disabled ? true : null"
  [attr.tabindex]="item().disabled ? -1 : null"
  [ngClass]="{
    'w-fit': !isExpanded(),
    rainbow: item().label === 'Lootboxen' && !item().disabled,
    'pointer-events-none opacity-40': item().disabled,
    'hover:bg-standard-hover-main': !item().disabled,
  }"
  class="text-s text-standard-text-primary relative flex items-center overflow-hidden rounded-xl px-2 py-2 transition-colors">
  @if (activeLink.isActive) {
    <span
      aria-hidden="true"
      class="bg-primary-main absolute inset-y-2 left-0 w-1 rounded-full"></span>
  }

  @if (item().icon.length > 0) {
    <span
      class="material-symbols-rounded text-2xl"
      [ngClass]="
        activeLink.isActive ? 'text-primary-main' : 'text-standard-icon'
      ">
      {{ item().icon }}
    </span>
  }

  @if (isExpanded()) {
    <span
      class="ml-3"
      [ngClass]="
        activeLink.isActive
          ? 'text-primary-main'
          : 'text-standard-text-primary'
      ">
      {{ item().label }}
    </span>
  }
</a>
